// (function () {
//     'use strict';
//
//     angular
//         .module('estadisticas')
//         .controller('GraficosMenuCtrl', GraficosMenuCtrl);

    /**
     * Controlador para el menu lateral de la sección de informes.
     */
    GraficosMenuCtrl.$inject = ['$state', '$stateParams', 'GraficoLocalService', 'stringUtils'];
    export default function GraficosMenuCtrl($state, $stateParams, GraficoLocalService, stringUtils) {
        var TAG = 'GraficosMenuCtrl: ';

        var vm = this;

        cargarGraficos();

        function cargarGraficos() {
            GraficoLocalService.getGraficos().then(function (graficos) {
                var partes = [
                    {
                        nombre: stringUtils.ucfirst(Lang.choice('nombres.incidencia', 1)),
                        graficos: graficos.filter(function (item) {
                            return item.variable_principal == 'incidencias';
                        })
                    },
                    {
                        nombre: stringUtils.ucfirst(Lang.choice('nombres.tarea', 1)),
                        graficos: graficos.filter(function (item) {
                            return item.variable_principal == 'tareas';
                        })
                    }
                ];
                vm.partes = partes;
            });

        }

        vm.irAGrafico = function (grafico) {
            $state.go('graficos.detail', {id: grafico.id});
        };

        vm.estaActivo = function (id) {
            return $state.params.id == id;
        }
    }
// })();